<form #loginForm="ngForm">
  <div class="ModalProps">
    <i class="fa fa-times CloseInfoDv" aria-hidden="true" (click)="closeDialog()"></i>
    <div class="item">
      <h3>Send Notification</h3>
    </div>
    <div class="item">
      <h2>Title:</h2>
      <input type="text" [(ngModel)]="insertNotificationDTO.title" id="title" name="title" #title="ngModel" required placeholder="Title:">
      <span *ngIf="title.invalid && loginForm.submitted"><p class="error" color="danger">*Title is required</p></span>
    </div>
    <div class="item">
      <h2>Body:</h2>
      <textarea type="text" [(ngModel)]="insertNotificationDTO.body" id="body" name="body" #body="ngModel" required placeholder="Body:"></textarea>
      <span *ngIf="body.invalid && loginForm.submitted"><p class="error" color="danger">*Body is required</p></span>
    </div>
    <div class="item">
      <h2>Type:</h2>
      <select type="text" [(ngModel)]="insertNotificationDTO.topic" id="type" name="type" #type="ngModel" required placeholder="Select Type:">
        <option value="all">All</option>
        <option value="consumer">Customer</option>
        <option value="vendor">Vendor</option>
      </select>
      <span *ngIf="type.invalid && loginForm.submitted"><p class="error" color="danger">*Type is required</p></span>
    </div>
    <div class="item">
      <button class="btn btn-primary" type="submit" (click)="submitForm(loginForm)">Submit</button>
    </div>
  </div>
</form>
